import PropTypes from 'prop-types';

// ----------------------------------------------------------------------

export default function FormLayout({ children }) {
  return <>{children}</>;
}

FormLayout.propTypes = {
  children: PropTypes.node,
};
